class HeaderSearch extends HTMLElement {
  constructor() {
    super();

    this.utilities = this.closest("[data-header-utilities]");
    this.toggle = this.querySelector("[data-search-toggle]");
    this.panel = this.querySelector("[data-search-panel]");
    this.clearButton = this.querySelector(".search-field__clear");
    this.input = this.querySelector(".search-field__input");

    this._isOpen = false;
    this._onExpand = this._onExpand.bind(this);

    this.toggle.addEventListener("click", () => {
      this._isOpen ? this._close() : this._open();
    });

    if (this.clearButton) {
      this.clearButton.addEventListener("click", () => {
        if (this._isOpen && !this.input.value) this._close();
      });
    }

    this.panel.addEventListener("focusout", (e) => {
      if (this.contains(e.relatedTarget)) return;

      this._close();
    });

    this.closeEsc = (e) => {
      if (e.key !== "Escape" || !this._isOpen) return;

      this._close();
      this.toggle.focus();
    };
    document.addEventListener("keydown", this.closeEsc);

    this.handleDocumentClick = (e) => {
      if (this._isOpen && !this.contains(e.target)) this._close();
    };
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("click", this.handleDocumentClick);
    this.panel.removeEventListener("transitionend", this._onExpand);
  }

  _onExpand(e) {
    if (e.target !== this.panel || e.propertyName !== "width") return;

    this.panel.removeEventListener("transitionend", this._onExpand);

    if (!this._isOpen) return;

    this.panel.classList.add("header__search-field--expanded");
    this.input?.focus();
  }

  _open() {
    this._isOpen = true;
    this.classList.add("open");
    this.toggle.setAttribute("aria-expanded", "true");
    this.utilities?.classList.add("header__utilities--searching");
    this.panel.addEventListener("transitionend", this._onExpand);
  }

  _close() {
    if (!this._isOpen) return;

    this._isOpen = false;
    this.classList.remove("open");
    this.panel.classList.remove("header__search-field--expanded");
    this.panel.removeEventListener("transitionend", this._onExpand);
    this.toggle.setAttribute("aria-expanded", "false");
    this.utilities?.classList.remove("header__utilities--searching");
  }
}

if (!customElements.get("header-search")) {
  customElements.define("header-search", HeaderSearch);
}
